let UserQueries = `https://yocq04ij55.execute-api.eu-central-1.amazonaws.com/prod/api/v1/`; //UserQueries
let AdminQueries = `https://wah4xd25j9.execute-api.eu-central-1.amazonaws.com/prod/api/v1/`; //AdminQueries
// https://cors-anywhere.herokuapp.com/
export const getAllCheckupsAPI = `${UserQueries}getallcheckups`;
export const createCheckupAPI = `${AdminQueries}createcheckup`;
export const getCheckupTypeAPI = `${AdminQueries}getcheckuptype`;

export const createUserAPI = `${AdminQueries}createuser`;
export const getAllUserAPI = `${AdminQueries}getallusers`;
export const getUserAPI = `${UserQueries}getuser`;
export const updateUserAPI = `${AdminQueries}updateuser`;
export const checkUserAPI = `${AdminQueries}checkuser`;

export const getListOfParksAPI = `${UserQueries}getallparks`;

export const getAllStationsAPI = `${AdminQueries}getallstations`;
export const getModulesByStationIDAPI = `${AdminQueries}getmodulesbystationid`;
export const getTasksByModuleIDAPI = `${AdminQueries}gettasksbymoduleid`;
export const getModulesAndStationRatingAPI = `${AdminQueries}getmodulesrating`

export const addTaskDesAPI = `${AdminQueries}addtaskdescription`;
export const getTaskDesAPI = `${UserQueries}gettaskdescription`;
export const updateTaskDesAPI = `${AdminQueries}updatetaskdescription`;
